/**
 * Ksting
 *
 * Copyright © 2017 Chris Andersson <chris@wbisbi.com>. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

import React, { Component } from 'react';
import { bool, shape, string } from 'prop-types';
import { NavLink, withRouter } from 'react-router-dom';
import { connect } from 'react-redux';

import p from 'polyglot/polyglot';

import { createUrl } from 'utils/urlHelper';

import StepHeader from 'components/StepHeader/StepHeader';

import styles from './application-status.scss';

/**
 * This is the ApplicationStatus component.
 *
 * @author Chris Andersson <chris@wbisbi.com>
 */
export class ApplicationStatus extends Component {
  /**
   * Declare expected prop types.
   *
   * @type {object}
   */
  static propTypes = {
    user: shape({
      is_client: bool.isRequired,
      firstname: string.isRequired,
    }).isRequired,
    pending: bool,
    rejected: bool,
  };

  /**
   * Declare default props.
   *
   * @type {object}
   */
  static defaultProps = {
    pending: false,
    rejected: false,
  };

  /**
   * Render ApplicationStatus.
   *
   * @return {Object}
   */
  render() {
    const {
      user: { is_client, firstname },
      pending,
      rejected,
    } = this.props;

    return (
      <article>
        {pending && (
          <StepHeader
            tagline={p.t('profile.hi_name', { name: firstname })}
            title={p.t('signup.application_status.pending.title')}
            current={is_client ? 7 : 6}
            total={is_client ? 7 : 6}
          />
        )}

        {rejected && (
          <StepHeader
            tagline={p.t('signup.application_status.rejected.tagline')}
            title={p.t('signup.application_status.rejected.title')}
            current={is_client ? 7 : 6}
            total={is_client ? 7 : 6}
          />
        )}

        <p className={styles.text}>
          {p.t('signup.application_status.return_text')}

          <NavLink to={createUrl('home')} className={styles.link}>
            {p.t('signup.application_status.return_link')}
          </NavLink>
        </p>
      </article>
    );
  }
}

export default withRouter(connect(({ user }) => ({ user }))(ApplicationStatus));
